import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { Patient } from "../../../models";

@Injectable()
export class CreatePatientGuard implements CanActivate {
  patient: Patient;

  constructor(public router: Router, private store: Store<any>) {
    store.select("patient").subscribe(patient => {
      this.patient = patient;
    });
  }

  canActivate(next: ActivatedRouteSnapshot) {
    let nextRoute =
      "/" +
      next.pathFromRoot
        .map(r => r.url)
        .filter(a => a.length)
        .join("/");
    if (
      nextRoute === "/patients/create/billing" &&
      this.verifyPatientProfile(this.patient)
    ) {
      return true;
    } else if (
      nextRoute === "/patients/create/physician" &&
      this.verifyPatientProfile(this.patient) &&
      this.verifyPatientBilling(this.patient)
    ) {
      return true;
    }

    this.router.navigate(["/patients/create/profile"]);
    return false;
  }

  verifyPatientProfile(patient) {
    return (
      patient &&
      patient.Address1 &&
      patient.City &&
      patient.Dob &&
      patient.FirstName &&
      patient.LastName &&
      patient.Phone &&
      patient.State &&
      patient.Zip
    );
  }

  verifyPatientBilling(patient) {
    return patient && patient.BillTo && patient.Provider && patient.PlanNumber;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/physician-portal/route-guards/create-patient.guard.ts